/** @format */

import React, { Component } from 'react';
import {
  Segment,
  Header,
  Table,
  Icon,
  Divider,
  Button,
} from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientAddresses extends Component {
  renderContentOrNull = content => {
    if (content !== null && content !== undefined && content !== '') {
      return content;
    } else {
      return null;
    }
  };

  renderAddresses = () => {
    const { ClientsStore } = this.props;
    let renderAddresses = null;
    let clientAddresses = ClientsStore.currentClient.addresses;
    if (clientAddresses !== null && clientAddresses !== undefined) {
      let clientAddressesKeys = Object.keys(clientAddresses);
      if (clientAddressesKeys.length > 0) {
        renderAddresses = clientAddressesKeys.map(addressKey => {
          return (
            <div key={'address-' + addressKey}>
              <small>
                <strong>
                  <Icon name="marker" />
                </strong>
              </small>
              {this.renderContentOrNull(
                clientAddresses[addressKey].data.address,
              )}
              &nbsp;
              {this.renderContentOrNull(
                clientAddresses[addressKey].data.address2,
              )}
              &nbsp;
              {this.renderContentOrNull(clientAddresses[addressKey].data.zip)}
              &nbsp;
              {this.renderContentOrNull(clientAddresses[addressKey].data.city)},
              {this.renderContentOrNull(clientAddresses[addressKey].data.state)}
              &nbsp;
              {this.renderContentOrNull(
                clientAddresses[addressKey].data.country,
              )}
              <br />
              <Divider className="reduced-margins" />
            </div>
          );
        });
      } else {
        return 'Nessun indirizzo registrato';
      }
    } else {
      return 'Nessun indirizzo registrato';
    }
    return renderAddresses;
  };

  render() {
    const { ClientsStore } = this.props;
    return (
      <Segment className="reqPart-box headed-segment" padded>
        <div className="segment-header smaller">
          <Header as="h4">
            <small>
              <Icon name="marker" />
            </small>
            Indirizzi
          </Header>
        </div>
        <Table compact basic="very" fixed celled>
          <Table.Body>
            <Table.Row>
              <Table.Cell>{this.renderAddresses()}</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
        <Button
          color="green"
          onClick={() => {
            ClientsStore.toggleAddressForm(
              ClientsStore.clientsParams.currentClientId,
              null,
            );
          }}
          size="small"
          fluid
        >
          <Icon name="plus" /> Aggiungi Indirizzo
        </Button>
      </Segment>
    );
  }
}

export default ClientAddresses;
